{
  "notifications": {
    "overline": "SETTINGS",
    "title": "Notifications",
    "titleHighlight": "Notifications",
    "signInHint": "Sign in to manage your notification preferences.",
    "loading": "Loading settings...",
    "loadError": "Couldn't load notification settings.",
    "retry": "Retry",
    "errorTitle": "Something went wrong",
    "desktop": "Desktop Notifications",
    "desktopHint": "Receive push notifications for event reminders and messages",
    "blockedInBrowser": "BLOCKED IN BROWSER",
    "blockedHint": "Notifications are blocked. Open your browser settings to allow notifications for this site.",
    "push": "Push notifications",
    "pushHint": "Get notified about messages and reminders on this device",
    "pushBlockedHint": "Notifications are disabled. Turn them on in your device settings.",
    "blockedInSystem": "DISABLED IN SETTINGS",
    "notificationsOn": "NOTIFICATIONS ON",
    "enableNotifications": "ENABLE NOTIFICATIONS",
    "reminderTime": "Reminder Time",
    "reminderTimeHint": "How early should we notify you before a live session starts?",
    "autoNotify": "Auto-Notify for Subscriptions",
    "autoNotifyHint": "Automatically create reminders for upcoming events by masters you follow.",
    "autoNotifyOn": "AUTO-NOTIFY ON",
    "autoNotifyOff": "AUTO-NOTIFY OFF",
    "footerNote": "These settings apply to browser push notifications. Make sure notifications are enabled in your browser.",
    "offset30min": "30 min",
    "offset1hour": "1 hour",
    "offset1_5hours": "1.5 hours",
    "offset2hours": "2 hours",
    "catSectionTitle": "Notifications",
    "catSectionHint": "Choose what to be told about. Everything is on by default.",
    "catMessages": "Messages",
    "catMessagesHint": "Notifications about new messages from friends and platform users.",
    "catMasterEvents": "New master events",
    "catMasterEventsHint": "Notifications when masters you follow create new online and offline events.",
    "catPracticeStart": "Practice start",
    "catPracticeStartHint": "Notifications when a master you follow starts a practice or Live session.",
    "catNewMedia": "New media and practices",
    "catNewMediaHint": "Notifications when a master publishes new content.",
    "catSystem": "System notifications",
    "catSystemHint": "Important notices about the platform, updates and changes.",
    "catPostEngagement": "Comments and reactions",
    "catPostEngagementHint": "When people comment on or react to your posts.",
    "subscriptions": "SUBSCRIPTIONS",
    "unavailable": "Settings are unavailable",
    "nativeFooter": "Reminders arrive as notifications about your events and your masters' sessions.",
    "catAgapellaProactive": "Agapella writes first",
    "catAgapellaProactiveHint": "Welcome-backs and nudges from the AI companion. Turn it off and Agapella will not start a conversation herself, but she stays available when you write. Platform notifications are unaffected. The weekly recap has its own switch.",
    "catAgapellaWeeklySummary": "Weekly recap",
    "catAgapellaWeeklySummaryHint": "Once a week Agapella sends a short recap to her chat: your practices, the minutes, and what you wrote about yourself. Entries hidden from AI are never used. Works once you have agreed to data processing in the AI chat."
  },
  "masterProfile": {
    "badge": {
      "required": "Required",
      "optional": "Optional"
    },
    "hints": {
      "name": "The name that users will see on your profile.",
      "experience": "How long have you been practising your chosen direction? State the number of years and key areas of work.",
      "education": "Studies, courses, certificates and schools — everything that influenced your professional path.",
      "uniqueness": "What sets your approach apart from other specialists? What makes you uniquely valuable to clients?",
      "philosophy": "What values underpin your work? Describe your mission and worldview."
    },
    "about": {
      "title": "About the master",
      "name": "Name",
      "namePlaceholder": "Your name",
      "directions": "Directions / practices",
      "experience": "Experience in practices",
      "experiencePlaceholder": "How long have you been practising your chosen direction?",
      "education": "Education / certification",
      "educationPlaceholder": "Studies, courses, certificates, schools.",
      "uniqueness": "Uniqueness of approach / methodology",
      "uniquenessPlaceholder": "How does your approach differ from other specialists?",
      "philosophy": "Philosophy / free description",
      "philosophyPlaceholder": "What values underpin your work?",
      "philosophyLabel": "Philosophy",
      "showMore": "Show more",
      "aboutMeTitle": "About me",
      "directionsTitle": "My directions",
      "directionsEmpty": "No directions listed yet."
    },
    "manifesto": {
      "title": "Video business card",
      "description": "Upload a video manifesto that will be displayed on your profile.",
      "emptyTitle": "No video card yet",
      "emptyHint": "Add one in settings — visitors see this block first.",
      "uploaded": "Video uploaded",
      "replace": "Replace",
      "upload": "Upload video",
      "uploadHint": "MP4, up to 500 MB",
      "cover": "Cover",
      "captureFrame": "Use current frame",
      "captureHint": "Pause the video at the right moment and choose the current frame as the cover.",
      "captureHintNoVideo": "First upload a video, then choose a frame as the cover.",
      "uploading": "Uploading…",
      "uploadingPercent": "Uploading {{percent}}%",
      "save": "Save video card",
      "webOnly": "Video upload is available in the web version.",
      "playbackError": "We can't show this video here yet. Open it in a new tab.",
      "openInNewTab": "Open in a new tab"
    },
    "path": {
      "title": "My journey",
      "addStep": "Add step",
      "description": "Tell us about your professional and personal journey.",
      "datePlaceholder": "2023-05",
      "eventPlaceholder": "What happened",
      "deleteStep": "Delete journey step"
    },
    "agape": {
      "title": "What Agape means to me",
      "upload": "Upload video",
      "description": "A video answer: what does Agape mean to me and how do I understand the Agape philosophy?",
      "uploaded": "Video uploaded",
      "replace": "Replace",
      "delete": "Delete",
      "uploading": "Uploading…",
      "uploadingPercent": "Uploading {{percent}}%",
      "save": "Save video",
      "webOnly": "Video upload is available in the web version."
    },
    "actions": {
      "cancel": "Cancel",
      "saveChanges": "Save changes",
      "savedOk": "All changes saved",
      "pathValidationError": "Fill in the date (YYYY-MM) and description for all journey steps",
      "requiredFieldsError": "Fill in the required fields: your name, at least one direction, and at least one «About» field."
    },
    "completion": {
      "title": "Profile completion",
      "sections": {
        "photo": "Profile photo",
        "about": "About the master",
        "manifesto": "Video intro",
        "directions": "Directions",
        "socials": "Social links",
        "path": "My path",
        "agape": "What Agape means to me"
      },
      "addSocials": "Add social links →",
      "calculating": "Calculating…",
      "motivationDone": "Profile complete",
      "motivationAlmost": "Almost there!",
      "motivationGood": "Good progress!",
      "motivationStart": "Good start!",
      "motivationEmpty": "Fill in your profile"
    },
    "required": {
      "title": "Required sections",
      "subtitle": "Fill in all required sections to publish your profile.",
      "aboutTitle": "About the master",
      "fieldsCount": "{{filled}}/{{total}} fields filled",
      "manifestoTitle": "Video business card",
      "manifestoAdded": "Video added",
      "manifestoMissing": "Upload your video card",
      "directionsTitle": "Directions",
      "directionsSelected_one": "{{count}} direction selected",
      "directionsSelected_other": "{{count}} directions selected",
      "directionsMissing": "Add at least 1 direction"
    },
    "legend": {
      "title": "Legend",
      "filled": "Section filled",
      "partial": "Section partially filled",
      "empty": "Section not filled",
      "optional": "Optional section",
      "hintTitle": "Tip",
      "hintText": "Click the icon next to a field to see examples and filling recommendations."
    },
    "socials": {
      "title": "Socials & resources",
      "settingsTitle": "Contacts and social links",
      "filled": "{{filled}} of {{total}} filled in",
      "loading": "Loading links…",
      "active": "Active",
      "needsFix": "Check this",
      "edit": "Edit",
      "add": "+ Add",
      "save": "Save",
      "errors": {
        "notAUrl": "Enter a valid {{platform}} link",
        "notAUrlWebsite": "Enter a valid website address",
        "wrongPlatform": "The link must point to {{platform}}",
        "placeholderHost": "That's an example address — enter your own",
        "serviceRoot": "Enter a profile address, not the {{platform}} home page",
        "tooLong": "That link is too long"
      },
      "saveError": "The link didn't save. Please try again.",
      "willSave": "Will be saved as {{url}}",
      "willClear": "Empty field — the link will be removed",
      "platforms": {
        "website": "Website",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "telegram": "Telegram",
        "rutube": "RuTube",
        "dzen": "Dzen",
        "vk": "VK"
      }
    },
    "account": {
      "title": "Account",
      "notifications": "Push and reminders",
      "notificationsDesc": "Browser permission and event reminder timing",
      "library": "Favorites",
      "libraryDesc": "Favorite practices and materials",
      "theme": "Theme",
      "themeDesc": "Interface appearance",
      "themeDark": "Dark",
      "themeLight": "Light",
      "themeSystem": "System",
      "security": "Login security",
      "securityDesc": "Passkey and password",
      "logout": "Log out"
    },
    "editors": {
      "section": "MASTER PROFILE",
      "profile": "Profile setup",
      "profileHint": "Photo, cover, name, city",
      "aboutHint": "Experience, education, philosophy",
      "directionsHint": "What you do",
      "pathHint": "Stages and events",
      "done": "Done",
      "hintA11y": "Hint for the «{{label}}» field",
      "cover": "Cover",
      "photo": "Profile photo",
      "location": "City / country",
      "locationPlaceholder": "For example, Moscow",
      "directionsNote": "Choose the directions you work in.",
      "pathNote": "Path stages: a date (YYYY-MM) and a description.",
      "dateFormat": "YYYY-MM",
      "saveFailed": "Couldn't save",
      "socialsNote": "Links to your profiles — they appear on your public master profile.",
      "aboutEmpty": "The profile is not filled in yet — add a description in the settings."
    },
    "visibility": {
      "title": "Profile visibility",
      "visible": "Your profile is visible",
      "visibleDesc": "People find you in the masters catalogue, by direct link and in Agapella's recommendations.",
      "hiddenByOwner": "Profile hidden",
      "hiddenByOwnerDesc": "Others can't see your profile in the catalogue or by direct link. You can still edit it — edits won't make it public without your decision.",
      "hiddenByAdmin": "Hidden by the platform",
      "hiddenByAdminDesc": "You can't restore it from here — only the Agapella team can.",
      "notPublished": "Profile not published",
      "notPublishedDesc": "There is no public version of your profile right now, so there is nothing to hide.",
      "keeps": "Hiding doesn't delete your account. Practices, recordings, Live sessions, subscriptions, purchases and chats stay, and ongoing conversations keep working.",
      "hide": "Hide profile",
      "unhide": "Show profile again",
      "confirmTitle": "Hide your profile?",
      "confirmBody": "Your profile, practices and Live sessions will no longer be shown to other people. You can make it visible again here at any time.",
      "confirm": "Hide",
      "cancel": "Cancel",
      "errors": {
        "nothingToHide": "Nothing to hide yet: your profile has no published version.",
        "hiddenByAdmin": "Your profile was hidden by the platform and can't be restored from here.",
        "noProfile": "Master profile not found.",
        "generic": "Couldn't save. Check your connection and try again."
      },
      "bannerOwner": "Your profile is hidden — it isn't shown in the catalogue or by link.",
      "bannerAdmin": "Your profile was hidden by the platform and isn't visible to others.",
      "bannerAction": "Visibility settings"
    }
  },
  "app": {
    "title": "Settings",
    "language": {
      "title": "Language",
      "hint": "App interface language"
    },
    "account": {
      "section": "ACCOUNT",
      "email": "EMAIL",
      "notifications": "Notifications",
      "notificationsHint": "Push and event reminders",
      "socials": "Social links",
      "socialsHint": "Links to your profiles",
      "library": "My library",
      "libraryHint": "Saved practices and playlists"
    },
    "privacy": {
      "section": "PRIVACY",
      "calendar": "Event calendar",
      "calendarHint": "Who can see which events you attend",
      "feed": "Practices in the feed",
      "feedHint": "Who can see the practices you add to your feed",
      "all": "Everyone",
      "subscribers": "Followers",
      "onlyMe": "Only me"
    },
    "assistant": {
      "section": "AGAPELLA",
      "proactive": "Proactive messages",
      "proactiveHint": "How often Agapella writes first",
      "normal": "Normal",
      "reduced": "Less often",
      "off": "Never",
      "aiData": "Data and AI",
      "consentGranted": "Consent to share messages with the AI service is given",
      "consentMissing": "Consent not given — the AI assistant chat is closed",
      "eraseTitle": "Delete your AI chat data?",
      "eraseBody": "This deletes the long-term memory, the profile built from it, and the conversation itself: whatever you told about yourself will have to be told again. This cannot be undone.",
      "eraseCancel": "Cancel",
      "eraseConfirm": "Delete",
      "eraseDoneTitle": "Done",
      "eraseDoneBody": "Memory, profile and your conversation with the assistant are deleted.",
      "erasePartialTitle": "Not everything was deleted",
      "erasePartialBody": "What is stored on the main server has been deleted. The conversation, the assistant’s long-term memory and the profile it built live in the chat service, which is unavailable right now, so they could not be deleted. Please try again later.",
      "eraseFailTitle": "Didn't work",
      "eraseFailBody": "Couldn't delete the data. Check your connection and try again, or write to info@agapella.io.",
      "revokeTitle": "Withdraw consent?",
      "revokeBody": "The AI companion chat will close, and everything already collected will be deleted: the long-term memory, the profile built from it, and the conversation. This cannot be undone.",
      "revokeConfirm": "Withdraw and delete",
      "memoryChatNote": "These are the notes the assistant has saved about you. This screen does not show the long-term memory of your conversations yet; you can delete all of it in Settings, under \"Data and AI\"."
    },
    "security": {
      "section": "ACCOUNT AND SECURITY",
      "blocked": "Blocked users",
      "blockedNone": "No one is blocked",
      "blockedCount_one": "{{count}} person",
      "blockedCount_other": "{{count}} people"
    },
    "legal": {
      "section": "LEGAL",
      "terms": "Terms of use",
      "termsHint": "Platform rules and code of conduct",
      "privacy": "Privacy policy",
      "privacyHint": "How we handle your data"
    },
    "marketing": {
      "title": "Promotional messages",
      "grantedHint": "You agreed to receive promotional messages. Tap to withdraw consent",
      "deniedHint": "We don't send you promotional messages. Tap to allow",
      "on": "Allowed",
      "off": "Not allowed",
      "errorRejected": "This consent can't be given right now: the server didn't accept it. If you have questions, please contact support.",
      "errorFailed": "Couldn't save your choice. Check your connection and try again."
    }
  },
  "securityScreen": {
    "passwordSection": "PASSWORD",
    "changePassword": "Change password",
    "setPassword": "Set a password",
    "changeHint": "We'll send a link to {{email}} — use it to change your password.",
    "setHint": "We'll send a link to {{email}} — use it to set a password.",
    "yourEmail": "your email",
    "sent": "Email sent. Check {{email}}.",
    "sendFailed": "Couldn't send the email",
    "passkeySection": "DEVICES AND PASSKEYS",
    "passkeyTitle": "Sign in with a passkey",
    "passkeyHint": "Passwordless sign-in with a passkey is available in the web version for now. We'll add it to the phone later."
  }
}
